import { EntityField, FieldType } from '../app/services/entities/entity-type.class';

export const allPlanningFields: { [key: string]: EntityField } = {
    user_id: {
        name: 'Gebruiker ID',
        type: FieldType.UserId,
        validators: {
            required: true,
        },
    },
    planning_has_id: {
        name: 'Planning Has ID',
        type: FieldType.Number,
        validators: {
            min: 0,
        },
    },
    status_key: {
        name: 'Status',
        type: FieldType.StatusKey,
        validators: {
            min: 0,
        },
    },
    performer: {
        name: 'Uitvoerder',
        type: FieldType.UserId,
    },
    contractor: {
        name: 'Opdrachtgever',
        type: FieldType.Text,
        validators: {
            maxLength: 255,
        },
    },
    worknumber: {
        name: 'Werkbonnummer',
        type: FieldType.Text,
        validators: {
            maxLength: 255,
        },
    },
    projectmanager: {
        name: 'Projectmanager',
        type: FieldType.UserId,
    },
    location: {
        name: 'Locatie',
        type: FieldType.Text,
        validators: {
            maxLength: 255,
        },
    },
    trucks: {
        name: 'Aantal vrachtwagens',
        type: FieldType.Number,
        validators: {
            min: 0,
        },
    },
    traffic_controllers: {
        name: 'Aantal verkeersregelaars',
        type: FieldType.Number,
        validators: {
            min: 0,
            max: 9999,
        },
    },
    mobile_crane: {
        name: 'Mobiele kraan',
        type: FieldType.Checkbox,
    },
    scatter: {
        name: 'Strooien',
        type: FieldType.Checkbox,
    },
    sticky_wagon: {
        name: 'Kleefwagen',
        type: FieldType.Text,
        validators: {
            maxLength: 255,
        },
    },
    description: {
        name: 'Beschrijving',
        type: FieldType.Textarea,
    },
    created_at: {
        name: 'Aangemaakt op',
        type: FieldType.DateTime,
    },
    updated_at: {
        name: 'Bijgewerkt op',
        type: FieldType.DateTime,
    },
    deleted_at: {
        name: 'Verwijderd op',
        type: FieldType.DateTime,
    },
    traffic: {
        name: 'Verkeer',
        type: FieldType.Text,
        validators: {
            maxLength: 255,
        },
    },
    pouring_off: {
        name: 'Gieten uit',
        type: FieldType.Text,
        validators: {
            maxLength: 255,
        },
    },
    tokband: {
        name: 'Tokband',
        type: FieldType.Text,
        validators: {
            maxLength: 255,
        },
    },
    hotbox: {
        name: 'Hotbox',
        type: FieldType.Checkbox,
    },
    asphalt_performer: {
        name: 'Asfalt uitvoerder',
        type: FieldType.UserId,
    },
    afas_project_id: {
        name: 'AFAS Project ID',
        type: FieldType.Text,
        validators: {
            maxLength: 255,
        },
    },
    comment: {
        name: 'Opmerking',
        type: FieldType.Textarea,
    },
    asphalt_location: {
        name: 'Asfalt locatie',
        type: FieldType.Text,
        validators: {
            maxLength: 255,
        },
    },
    is_transport: {
        name: 'Is transport',
        type: FieldType.Checkbox,
        validators: {
            required: true,
        },
    },
    size: {
        name: 'Grootte',
        type: FieldType.Text,
        validators: {
            maxLength: 255,
        },
    },
    leave_id: {
        name: 'Verlof ID',
        type: FieldType.Number,
        validators: {
            min: 0,
        },
    },
    resident_letter: {
        name: 'Bewonersbrief',
        type: FieldType.Text,
        validators: {
            maxLength: 255,
        },
    },
};

export const allPheFields: { [key: string]: EntityField } = {
    entitytype_key: {
        name: 'Entitytype Sleutel',
        type: FieldType.Text,
        validators: {
            maxLength: 255,
        },
    },
    entity_id: {
        name: 'Entity ID',
        type: FieldType.EntityId,
    },
    planning_id: {
        name: 'Planning ID',
        type: FieldType.Number,
        validators: {
            min: 0,
        },
    },
    afas_project_id: {
        name: 'AFAS Project ID',
        type: FieldType.Text,
        validators: {
            maxLength: 255,
        },
    },
    driver_user_id: {
        name: 'Chauffeur Gebruiker ID',
        type: FieldType.UserId,
        asyncValidators: [
            {
                type: 'localUserIsAvailable',
                config: {
                    beginDateField: 'begindate',
                    endDateField: 'enddate',
                },
            },
        ],
    },
    truck_entity_id: {
        name: 'Vrachtwagen Entity ID',
        type: FieldType.EntityId,
    },
    lowloader_entity_id: {
        name: 'Dieplader Entity ID',
        type: FieldType.EntityId,
    },
    begindate: {
        name: 'Begindatum',
        type: FieldType.DateTime,
    },
    work_begindate: {
        name: 'Werk Begindatum',
        type: FieldType.DateTime,
    },
    work_enddate: {
        name: 'Werk Einddatum',
        type: FieldType.DateTime,
    },
    enddate: {
        name: 'Einddatum',
        type: FieldType.DateTime,
    },
    name: {
        name: 'Naam',
        type: FieldType.Text,
        validators: {
            maxLength: 255,
        },
    },
    transport_origin: {
        name: 'Transport Oorsprong',
        type: FieldType.Text,
        validators: {
            maxLength: 255,
        },
    },
    transport_worksite: {
        name: 'Transport Werkplaats',
        type: FieldType.Text,
        validators: {
            maxLength: 255,
        },
    },
    transport_worksite_end: {
        name: 'Transport Werkplaats Eind',
        type: FieldType.Text,
        validators: {
            maxLength: 255,
        },
    },
    transport_destination: {
        name: 'Transport Bestemming',
        type: FieldType.Text,
        validators: {
            maxLength: 255,
        },
    },
    driver: {
        name: 'Chauffeur',
        type: FieldType.Text,
        validators: {
            maxLength: 150,
        },
    },
    location: {
        name: 'Locatie',
        type: FieldType.Text,
        validators: {
            maxLength: 250,
        },
    },
    tons: {
        name: 'Tonnen',
        type: FieldType.Number,
        validators: {
            min: 0,
        },
    },
    thickness: {
        name: 'Dikte',
        type: FieldType.Number,
        validators: {
            min: 0,
        },
    },
    trucks: {
        name: 'Vrachtwagens',
        type: FieldType.Number,
    },
    comment: {
        name: 'Opmerking',
        type: FieldType.Textarea,
        validators: {
            maxLength: 3000,
        },
    },
    order: {
        name: 'Volgorde',
        type: FieldType.Number,
    },
    created_at: {
        name: 'Aangemaakt op',
        type: FieldType.DateTime,
    },
    updated_at: {
        name: 'Bijgewerkt op',
        type: FieldType.DateTime,
    },
    deleted_at: {
        name: 'Verwijderd op',
        type: FieldType.DateTime,
    },
    wdr: {
        name: 'WDR',
        type: FieldType.Text,
        validators: {
            maxLength: 300,
        },
    },
    count: {
        name: 'Aantal',
        type: FieldType.Number,
        validators: {
            min: 0,
            required: true,
        },
    },
    hiring_id: {
        name: 'Inhuur ID',
        type: FieldType.Number,
        validators: {
            min: 0,
        },
    },
    performer_id: {
        name: 'Uitvoerder ID',
        type: FieldType.UserId,
    },
    type: {
        name: 'Type',
        type: FieldType.Text,
        validators: {
            maxLength: 255,
        },
    },
    drawing: {
        name: 'Tekening',
        type: FieldType.Text,
        validators: {
            maxLength: 255,
        },
    },
    vg_plan: {
        name: 'VG Plan',
        type: FieldType.Text,
        validators: {
            maxLength: 255,
        },
    },
    mechanic_id: {
        name: 'Monteur ID',
        type: FieldType.UserId,
    },
};
